// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__34iaY","paramInput":"JobSimulator_paramInput__3tuml","input":"JobSimulator_input__1Id4N"};